
    /**
    * Linear interpolation.
    * IMPORTANT:will return `Infinity` if numbers overflow Number.MAX_VALUE
    */
    function lerp(ratio, start, end){
        return start + (end - start) * ratio;
    }

    module.exports = lerp;




//////////////////
// WEBPACK FOOTER
// ./~/mout/math/lerp.js
// module id = 701
// module chunks = 0 1 2